import Server from '../../libs/server'

const apis = {
  fetchCert: [ '/cert/diploma/fetch', 'get' ],
  certSendApply: [ '/cert/send/apply', 'get' ]
}

export default {
  namespaced: true,

  actions: {
    async fetchCert (store, courseId) {
      const [ url, method ] = apis.fetchCert
      const { data } = await Server({
        url,
        method,
        loading: true,
        data: { courseId }
      })
      return data
    },

    async certSendApply (store, diplomaId) {
      const [ url, method ] = apis.certSendApply
      await Server({
        url,
        method,
        data: { diplomaId }
      })
    }
  }
}
